var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#828292",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2634_31800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C15.3125 24 18.1406 22.8281 20.4844 20.4844C22.8281 18.1406 24 15.3125 24 12C24 8.6875 22.8281 5.85938 20.4844 3.51562C18.1406 1.17188 15.3125 0 12 0C8.6875 0 5.85937 1.17188 3.51562 3.51563C1.17187 5.85938 0 8.6875 0 12C0 15.3125 1.17188 18.1406 3.51562 20.4844C5.85938 22.8281 8.6875 24 12 24ZM21.9844 12C21.9844 14.75 21.0078 17.1016 19.0547 19.0547C17.1016 21.0078 14.75 21.9844 12 21.9844C9.53125 21.9844 7.4375 21.2188 5.71875 19.6875L19.6875 5.71875C21.2187 7.4375 21.9844 9.53125 21.9844 12ZM12 2.01562C14.4687 2.01562 16.5625 2.78125 18.2812 4.3125L4.3125 18.2813C2.78125 16.5625 2.01562 14.4688 2.01562 12C2.01562 9.25 2.99219 6.89844 4.94531 4.94531C6.89844 2.99219 9.25 2.01563 12 2.01562Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/Forbidden.087486e0.svg";
export { ForwardRef as ReactComponent };